import type { Path } from '@ardoq/api-types';
import { trackEventV2 } from 'tracking/tracking';
import { countTraversalHops } from './countTraversalHops';

export type DatasetAppliedSurface = 'viewpoint_builder' | 'sidebar_panel';

export type DatasetAppliedTrigger = 'create' | 'edit';

type DatasetAppliedArgs = {
  surface: DatasetAppliedSurface;
  trigger: DatasetAppliedTrigger;
  paths: Path[];
};

type PathStats = {
  pathCount: number;
  longestPath: number;
  hopCount: number;
  componentTypeCount: number;
  referenceTypeCount: number;
};

const countDistinct = (values: string[]): number => new Set(values).size;

const toPathStats = (paths: Path[]): PathStats => {
  const triples = paths.flat();
  return {
    pathCount: paths.length,
    longestPath: Math.max(0, ...paths.map(path => path.length)),
    hopCount: countTraversalHops(paths),
    componentTypeCount: countDistinct(
      triples.flatMap(({ sourceType, targetType }) => [sourceType, targetType])
    ),
    referenceTypeCount: countDistinct(
      triples.map(({ referenceType }) => referenceType)
    ),
  };
};

const datasetApplied = ({
  surface,
  trigger,
  paths,
}: DatasetAppliedArgs): void =>
  trackEventV2({
    event: 'Datasets0 dataset applied',
    payload: { surface, trigger, ...toPathStats(paths) },
  });

export const datasetTracking = {
  datasetApplied,
};
